






import {Component, Vue, Prop} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {ProfileState} from '../../store/modules/profile'
import Avatar from '../proxy/Avatar.vue'
import {PopupState} from '../../store'
import LoginView from '@/views/Login.vue'

@Component({
  components: {Avatar},
})
export default class ProfileButton extends Vue {
  @Action('openPopup') public openPopup!: (popup: PopupState) => void
  @State('profile') public profileState!: ProfileState

  protected open() {

    if (this.profileState.driver == null) {
      this.openPopup(new PopupState(LoginView, null))
    } else {
      this.$router.push('/profile')
    }
  }

  get profilePicture() {
    return this.profileState.driver ? this.profileState.driver.profile_picture : 'img/no-login.png'
  }
}
